import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import bgImg from '../../assets/KRTMIZ_3762-scaled.jpg';
import logoImg from '../../assets/Project_Green_Logo_White_RGB.png';

export default function LoginModal() {
  const { instance } = useMsal();
  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap"
        rel="stylesheet"
      />
      <div style={styles.overlay}>

        <img src={logoImg} alt="Project Green" style={styles.logo} />

        <img src={bgImg} alt="" style={styles.bgImage} />

        <div style={styles.modal}>
          <h1 style={styles.title}>WELCOME</h1>
          <button
            style={styles.button}
            onClick={handleLogin}
            onMouseEnter={e => {
              e.currentTarget.style.background = '#7d9a46';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(149,178,88,0.45)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = '#95b258';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Sign in with Microsoft
          </button>
          <p style={styles.notice}>Use your organization account to continue.</p>
        </div>

      </div>
    </>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Poppins', sans-serif",
    zIndex: 9999,
    overflow: 'hidden',
  },
  bgImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'brightness(0.82)',
    zIndex: 0,
  },
  logo: {
    position: 'absolute',
    top: 0,
    left: 28,
    height: 120,
    zIndex: 2,
  },
  modal: {
    position: 'relative',
    zIndex: 2,
    background: '#f5f5e8',
    borderRadius: 20,
    borderLeft: '7px solid #95b258',
    padding: '3.5rem 3rem 3rem',
    width: '100%',
    maxWidth: 440,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 700,
    fontSize: '3rem',
    color: '#132a2c',
    letterSpacing: '0.06em',
    margin: '0 0 2.5rem 0',
  },
  button: {
    width: '100%',
    padding: '0.9rem 1rem',
    background: '#95b258',
    color: '#fff',
    border: 'none',
    borderRadius: 40,
    fontFamily: "'Poppins', sans-serif",
    fontSize: '1rem',
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: '1.2rem',
    letterSpacing: '0.02em',
    transition: 'background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
  },
  notice: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '0.85rem',
    color: '#555',
    lineHeight: 1.6,
    margin: 0,
  },
};